import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=0b8b2d3b&scoped=true&"
import script from "./sponsors.vue?vue&type=script&lang=js&"
export * from "./sponsors.vue?vue&type=script&lang=js&"
import style0 from "./sponsors.vue?vue&type=style&index=0&id=0b8b2d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b2d3b",
  null
  
)

export default component.exports